function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var FaceID = function FaceID(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    d: "M15.37 15.403a.75.75 0 1 1 1.06 1.06c-.705.706-1.98 1.6-4.214 1.6-2.22 0-3.782-1.014-4.349-1.615l1.091-1.029c.3.319 1.475 1.143 3.258 1.144 1.767 0 2.676-.683 3.153-1.16m-7.472-.015a.75.75 0 0 1 1.06.031l-1.09 1.03a.75.75 0 0 1 .03-1.061m3.88-3.585V9.59a.75.75 0 0 1 1.5 0v2.213a1.83 1.83 0 0 1-1.829 1.829h-.565a.75.75 0 0 1 0-1.5h.565a.33.33 0 0 0 .33-.33M6.875 9.02v-.77a.75.75 0 1 1 1.5 0v.77a.75.75 0 0 1-1.5 0m9.063 0v-.77a.75.75 0 0 1 1.5 0v.77a.75.75 0 0 1-1.5 0M1.25 6.375V5.272A4.023 4.023 0 0 1 5.272 1.25h1.103l.077.004a.75.75 0 0 1 0 1.492l-.077.004H5.272A2.523 2.523 0 0 0 2.75 5.272v1.103a.75.75 0 0 1-1.5 0M22.75 6.375V5.272a4.023 4.023 0 0 0-4.023-4.022h-1.103l-.077.004a.75.75 0 0 0 0 1.492l.077.004h1.103a2.523 2.523 0 0 1 2.522 2.522v1.103a.75.75 0 0 0 1.5 0M22.75 17.625v1.102a4.023 4.023 0 0 1-4.023 4.023h-1.103l-.077-.004a.75.75 0 0 1 0-1.492l.077-.004h1.103a2.523 2.523 0 0 0 2.522-2.523v-1.102a.75.75 0 0 1 1.5 0M1.25 17.625v1.102a4.023 4.023 0 0 0 4.022 4.023h1.103l.077-.004a.75.75 0 0 0 0-1.492l-.077-.004H5.272a2.523 2.523 0 0 1-2.522-2.523v-1.102a.75.75 0 0 0-1.5 0"
  }));
};
export default FaceID;
FaceID.displayName = 'FaceID';